import { useCallback, useState } from 'react'
//@ts-ignore
import { Pannellum } from "pannellum-react";
import './View3D.css'
import { Info, } from '../../../components/icons';
import Popup from './Popup';
import { isMobile } from 'react-device-detect'
import styled from 'styled-components'
import Theme from '../../../Theme';
import RotateDevice from '../../../components/icons/RotateDevice';
import Loading360 from '../../../assets/lottie/Loading360.json'
import Lottie from 'react-lottie';
import { locations } from '../../../other/constants';
import useMobile from '../../../other/Hooks/useMobile';
import { NavBar } from '../../../components/core';

const InfoContainer = styled.div`
    position:absolute;
    height:28px;
    width:28px;
    right:5%;
    bottom:5%;

    @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
    bottom: 60px;

    }


`
const IconContainer = styled.div`
    position:absolute;
    width:100%;
    height:100%;
    top:0;
    display:flex;
    justify-content:center;
    align-items:center;
    flex-direction:column;
    z-index: 11;
    `

export function ClickAndDrag({ LS_NAME }: { LS_NAME: string }) {
    const isMobile = useMobile()
    const [dragged, setDragged] = useState(localStorage.getItem(LS_NAME))

    const onDrag = useCallback(() => {
        setDragged(LS_NAME)
        localStorage.setItem(LS_NAME, LS_NAME)
    }, [])

    if (dragged || isMobile) return null

    return (
        <IconContainer
            onClick={onDrag}
            onMouseDown={onDrag}
            onTouchStart={onDrag}
        >
            <svg width="444" height="282" viewBox="0 0 444 282" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="444" height="282" fill="black" fillOpacity="0.6" />
                <path className='hand' d="M239.145 68.6667H236.636C236.636 67.84 235.8 66.1867 234.964 65.36C234.127 64.5333 232.455 63.7067 230.364 63.7067C229.527 63.7067 228.691 63.7067 227.855 64.12C227.436 63.2933 227.018 62.88 226.6 62.0533C225.764 61.2267 224.509 60.4 222 60.4C221.164 60.4 220.327 60.4 219.909 60.8133V53.7867C219.909 51.3067 218.236 48 214.055 48C212.382 48 210.709 48.8267 209.455 49.6533C207.364 52.1333 207.364 55.44 207.364 55.44V73.2133C204.855 73.6267 202.764 74.4533 201.509 75.6933C199 78.5867 199 82.3067 199 87.2667V90.16C199 95.9467 201.927 98.84 204.855 101.733L206.109 103.387C211.545 108.347 216.145 110 227.436 110C239.564 110 245 103.387 245 88.92V78.5867C245 75.6933 244.164 69.9067 239.145 68.6667ZM240.818 78.5867V89.3333C240.818 103.387 235.382 106.28 227.436 106.28C217.4 106.28 213.636 105.04 209.455 100.907L207.782 99.2533C204.855 95.9467 203.182 94.2933 203.182 90.16V87.2667C203.182 83.1333 203.182 80.24 204.436 78.5867C204.855 78.1733 206.109 77.76 207.364 77.76V79.8267L206.109 86.0267C206.109 86.44 206.109 86.44 206.527 86.8533C206.945 87.2667 207.364 86.8533 207.364 86.8533L211.545 81.8933V55.44C211.545 55.0267 211.545 53.3733 212.382 52.5467C212.8 52.5467 213.218 52.1333 214.055 52.1333C215.309 52.1333 215.727 53.3733 215.727 53.7867V71.56C215.727 72.8 216.564 74.04 217.818 74.04C219.073 74.04 219.909 72.8 219.909 71.9733V66.6C219.909 66.1867 220.327 64.5333 222 64.5333C223.255 64.5333 224.091 64.9467 224.091 66.1867V71.56C224.091 72.8 224.927 74.04 226.182 74.04C227.436 74.04 228.273 72.8 228.273 71.9733V69.08C228.273 68.6667 228.691 67.84 230.364 67.84C231.2 67.84 231.618 68.2533 231.618 68.2533C232.455 68.6667 232.455 69.9067 232.455 69.9067V73.2133C232.455 74.4533 233.291 75.28 234.127 75.28C235.382 75.28 236.218 74.8667 236.218 73.6267C236.218 73.2133 236.636 72.8 237.055 72.3867H237.891C240.4 73.2133 240.818 77.3467 240.818 78.5867C240.818 78.1733 240.818 78.1733 240.818 78.5867V78.5867Z" fill="#F8971D" />
                <g filter="url(#filter0_d)">
                    <path d="M82.0706 168.408C87.2386 168.408 90.0946 165.654 91.7266 162.832L87.5786 160.826C86.6266 162.696 84.5866 164.124 82.0706 164.124C78.1266 164.124 75.1346 160.962 75.1346 156.678C75.1346 152.394 78.1266 149.232 82.0706 149.232C84.5866 149.232 86.6266 150.694 87.5786 152.53L91.7266 150.49C90.1287 147.668 87.2386 144.948 82.0706 144.948C75.4406 144.948 70.1706 149.708 70.1706 156.678C70.1706 163.648 75.4406 168.408 82.0706 168.408ZM105.6 168H120.016V163.75H110.428V145.322H105.6V168ZM134.397 168H139.225V145.322H134.397V168ZM165.539 168.408C170.707 168.408 173.563 165.654 175.195 162.832L171.047 160.826C170.095 162.696 168.055 164.124 165.539 164.124C161.595 164.124 158.603 160.962 158.603 156.678C158.603 152.394 161.595 149.232 165.539 149.232C168.055 149.232 170.095 150.694 171.047 152.53L175.195 150.49C173.597 147.668 170.707 144.948 165.539 144.948C158.909 144.948 153.639 149.708 153.639 156.678C153.639 163.648 158.909 168.408 165.539 168.408ZM202.533 168H208.483L198.861 155.964L207.871 145.322H201.921L193.897 155.454V145.322H189.069V168H193.897V161.03L195.665 158.922L202.533 168ZM227.114 157.868H233.2V155.182H227.114V148.552H224.156V155.182H218.036V157.868H224.156V164.77H227.114V157.868ZM247.427 168H256.369C263.475 168 268.405 163.512 268.405 156.678C268.405 149.844 263.475 145.322 256.369 145.322H247.427V168ZM252.255 163.75V149.572H256.369C261.027 149.572 263.475 152.666 263.475 156.678C263.475 160.52 260.857 163.75 256.369 163.75H252.255ZM295.649 168H301.191L296.091 159.364C298.539 158.786 301.055 156.644 301.055 152.632C301.055 148.416 298.165 145.322 293.439 145.322H282.831V168H287.659V159.874H291.195L295.649 168ZM296.125 152.598C296.125 154.502 294.663 155.726 292.725 155.726H287.659V149.47H292.725C294.663 149.47 296.125 150.694 296.125 152.598ZM331.557 168H336.827L328.089 145.322H322.037L313.265 168H318.569L319.997 164.09H330.129L331.557 168ZM325.063 149.504L328.803 159.908H321.289L325.063 149.504ZM347.671 156.678C347.671 163.818 353.111 168.442 359.741 168.442C363.855 168.442 367.085 166.742 369.397 164.158V155.488H358.585V159.636H364.637V162.39C363.651 163.274 361.815 164.124 359.741 164.124C355.627 164.124 352.635 160.962 352.635 156.678C352.635 152.394 355.627 149.232 359.741 149.232C362.121 149.232 364.059 150.49 365.113 152.088L369.125 149.912C367.391 147.226 364.433 144.948 359.741 144.948C353.111 144.948 347.671 149.504 347.671 156.678ZM63.7066 223H68.5686V204.572H75.1646V200.322H57.0766V204.572H63.7066V223ZM87.3415 211.678C87.3415 218.512 92.3395 223.408 99.1735 223.408C106.042 223.408 111.04 218.512 111.04 211.678C111.04 204.844 106.042 199.948 99.1735 199.948C92.3395 199.948 87.3415 204.844 87.3415 211.678ZM106.076 211.678C106.076 215.894 103.356 219.124 99.1735 219.124C94.9915 219.124 92.3055 215.894 92.3055 211.678C92.3055 207.428 94.9915 204.232 99.1735 204.232C103.356 204.232 106.076 207.428 106.076 211.678ZM160.767 223H165.425V200.322H160.597V215.01L150.091 200.322H145.127V223H149.955V207.768L160.767 223ZM196.774 223H202.044L193.306 200.322H187.254L178.482 223H183.786L185.214 219.09H195.346L196.774 223ZM190.28 204.504L194.02 214.908H186.506L190.28 204.504ZM219.903 223H225.955L234.693 200.322H229.185L222.929 217.764L216.639 200.322H211.131L219.903 223ZM247.787 223H252.615V200.322H247.787V223ZM267.029 211.678C267.029 218.818 272.469 223.442 279.099 223.442C283.213 223.442 286.443 221.742 288.755 219.158V210.488H277.943V214.636H283.995V217.39C283.009 218.274 281.173 219.124 279.099 219.124C274.985 219.124 271.993 215.962 271.993 211.678C271.993 207.394 274.985 204.232 279.099 204.232C281.479 204.232 283.417 205.49 284.471 207.088L288.483 204.912C286.749 202.226 283.791 199.948 279.099 199.948C272.469 199.948 267.029 204.504 267.029 211.678ZM319.233 223H324.503L315.765 200.322H309.713L300.941 223H306.245L307.673 219.09H317.805L319.233 223ZM312.739 204.504L316.479 214.908H308.965L312.739 204.504ZM340.642 223H345.504V204.572H352.1V200.322H334.012V204.572H340.642V223ZM366.195 223H382.243V218.818H371.023V213.548H382.005V209.4H371.023V204.47H382.243V200.322H366.195V223Z" fill="white" />
                </g>
                <defs>
                    <filter id="filter0_d" x="42.0766" y="129.948" width="355.167" height="108.494" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                        <feOffset />
                        <feGaussianBlur stdDeviation="7.5" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                    </filter>
                </defs>
            </svg>
        </IconContainer>
    )
}

type Props = {
    changeScreen: () => void
    setView3D: any
    setLocation: any
    backToSplit: any
    location: string
}

export default function View360({ location, backToSplit, changeScreen, setView3D, setLocation }: Props) {
    const [loading, setLoading] = useState(true)
    const [expand, setExpand] = useState(false)
    const isPortrait = window.matchMedia('(orientation:portrait)').matches

    return (
        <>
            <NavBar
                backToSplit={() => {
                    setView3D()
                    setLocation()
                }}
                onClick={() => {
                    setView3D()
                    setLocation()
                    changeScreen()
                }}
                text='TAKE THE VIRTUAL TOUR'
                position={'left'}
                showBack={!!expand}
            />

            <Pannellum
                width="100vw"
                height={window.innerHeight}
                /* @ts-ignore */
                image={locations[location].img360}
                autoLoad={true}
                onLoad={() => setLoading(false)}
                showControls={false} />
            {
                loading &&
                <IconContainer>

                    <Lottie options={{
                        animationData: Loading360,
                        loop: true,
                        autoplay: true,
                        rendererSettings: {
                            preserveAspectRatio: 'xMidYMid slice'
                        }
                    }}
                        width={166}
                        height={207}
                    />

                    {
                        isPortrait &&
                        <RotateDevice />
                    }
                </IconContainer>
            }
            {!loading && <ClickAndDrag LS_NAME='liuana_img' />}
            {
                isMobile && !loading &&
                <>
                    { !expand &&

                        <InfoContainer onClick={() => setExpand(true)}>
                            <Info fillColor={Theme.colors.White} />
                        </InfoContainer>
                    }
                    {
                        expand &&
                        <Popup location={location} closePopup={() => setExpand(false)} />
                    }
                </>
            }
            { !isMobile && !loading &&
                <Popup
                    collapsed={!expand && !loading}
                    location={location}
                    closePopup={() => setExpand(false)}
                    openPopup={() => setExpand(true)}
                />
            }
        </>
    )
}
